/* eslint-disable */
"use strict";

import { mapGetters } from "vuex";
import { URL, apiCall } from "@/utils/api";
import GLOBALS from "../global/store";
import { getExecutives as getExecs } from "../apis/structures";
const priorityLevels = [
  { name: "CRITICAL", title: "Təcili", color: "red" },
  { name: "NORMAL", title: "Orta", color: "orange" },
  { name: "LOW", title: "Aşağı", color: "green" },
];

var mixin = {
  data() {
    return {
      pageLoading: false,
      mycardBodyStyle: { padding: "10px" },
      mylocale: { emptyText: "Məlumat yoxdur" },
      tagColors: [
        "red",
        "orange",
        "green",
        "cyan",
        "pink",
        "blue",
        "purple",
        "aqua",
        "brown",
        "whitesmoke",
        "black",
        "violet",
        "salmon",
      ],
      respFileTypes:
        ".doc,.docx,.pdf,.jpg,.mp4,.png,.bmp,.jpeg,.mp3,.aac, .xlsx, .txt",
      respFileTypesList: ".doc,.docx,.pdf,.jpg,.mp4,.png,.bmp,.jpeg,.mp3,.aac, .xlsx, .txt"
        .split(",")
        .map((type) => type.trim()),
      appealFileTypes: ".jpg,.mp4,.png,.bmp,.jpeg,.mp3,.aac",
      showDatetimeFormat: "DD.MM.YYYY HH:mm:ss",
      opDatetimeFormat: "DD.MM.YYYY HH:mm:ss",
      dpLocale: GLOBALS.azDataPickerLocale,
      uploadConf: { showPreviewIcon: false },

      priorityLevels,
    };
  },
  computed: {
    ...mapGetters({
      userGroupType: "user/userGroupType",
      userData: "user/userData",
      user: "user/user",
      currentStep: "user/currentStep",
    }),
    problemStructureTxt: function () {
      return (
        (this.problem.representation
          ? this.problem.representation.name + " , "
          : "") + this.problem.executive.name
      );
    },
  },
  methods: {
    getCitizenAppeals({ problemId, detailed, officeDetailId }) {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "appeals/",
        params: {
          problemId: problemId,
          officeDetId: officeDetailId,
          detailed: detailed,
        },
      })
        .then((response) => {
          if (!response.data.error) {
            let appeals = response.data.data;
            this.$set(this.problem, "appeals", appeals);
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    getCategories(isNew=false) {
      return apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "categories?isNew="+isNew,
      }).catch((err) => {
        this.$message.error("Xəta baş verdi");
        console.log(err);
      });
    },
    convertDateToString(date) {
      const mydate = new Date(date);
      const month = mydate.getMonth() + 1;
      const day = mydate.getDate();
      const hour = mydate.getHours();
      const minutes = mydate.getMinutes();
      return (
        mydate.getFullYear() +
        "-" +
        (month.toString().length == 1 ? "0" + month : month) +
        "-" +
        (day.toString().length == 1 ? "0" + day : day) +
        " " +
        (hour.toString().length == 1 ? "0" + hour : hour) +
        ":" +
        (minutes.toString().length == 1 ? "0" + minutes : minutes)
      );
    },
    getActions(problemId, officeDetailId) {

      return apiCall({
        url: URL[process.env.NODE_ENV].service_api + "problems/actions",
        method: "GET",
        params: {
          menuUrl:
            window.location.pathname.split("/").length == 0
              ? ""
              : window.location.pathname.split("/")[1],
          officeDetId: officeDetailId,
          problemId: problemId,
        },
      });
    },
    getOperationText(operation) {
      if (!operation) return null;
      return (
        operation.opUser.firstName +
        " " +
        operation.opUser.lastName +
        " " +
        operation.opUser.fatherName +
        " (" +
        operation.opUserStep.name +
        ")  " +
        operation.dateStr +
        " tarixində " +
        operation.direction.action.inSentence
      );
    },
    getProblemApplicants(id) {
      // console.log("problem applicants called", id)
      apiCall({
        url: `${URL[process.env.NODE_ENV].service_api}problems/${
          id || this.$route.params.id
        }/applicants`,
        method: "GET",
      })
        .then((response) => {
          // console.log("applicants", response.data);
          if (!response.data.error) {
            this.applicants = response.data.data;
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err.dir);
          // this.pageLoading = false;
        });
    },
    getExecutors() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "executors",
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error) {
            this.executors = response.data.data.entities;
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    calculateDayAndHour(executeDetail) {
      //console.log('here');
      let delayTime = Math.abs(executeDetail.delayTime);
      let second = Math.floor(delayTime / 1000);
      let minute = Math.floor(second / 60);
      second = second % 60;
      let hour = Math.floor(minute / 60);
      minute = minute % 60;
      let day = Math.floor(hour / 24);
      hour = hour % 24;
      let month = Math.floor(day / 30);
      if (day >= 30) day %= 30;
      return (
        (executeDetail.delayTime < 0 ? "İcra son tarixə " : "İcra prosesi ") +
        (month > 0 ? month + " ay " : "") +
        (day > 0 ? day + " gün " : "") +
        (hour > 0 ? hour + " saat " : "") +
        (minute > 0 ? minute + " dəqiqə " : "") +
        (executeDetail.delayTime < 0 ? " qalıb " : " gecikib")
      );
    },
    calculateDifference(date1, date2) {
      let difference = date2 - date1;
      let second = Math.floor(difference / 1000);
      let minute = Math.floor(second / 60);
      second = second % 60;
      let hour = Math.floor(minute / 60);
      minute = minute % 60;
      let day = Math.floor(hour / 24);
      hour = hour % 24;
      let month = Math.floor(day / 30);
      return (
        (month > 0 ? month + " ay " : "") +
        (day > 0 ? day + " gün " : "") +
        (hour > 0 ? hour + " saat " : "") +
        (minute > 0 ? minute + " dəqiqə " : "")
      );
    },
    getSteps(structureId) {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "steps",
        method: "GET",
        params: { structureId: structureId },
      })
        .then((response) => {
          if (!response.data.error) this.steps = response.data.data;
          else this.$message.error(response.data.error.message);
        })
        .catch((error) => {
          this.$message.error("Xəta baş verdi");
          this.steps = [];
        });
    },
    handleRepAfterClose() {
      this.representationModalVisibility = false;
    },
    handleRepChange(rep) {
      this.problem.representation = rep;
      this.representationModalVisibility = false;
    },
    getParentOffices() {
      if (
        this.privilege.selectParentOffice != "REQUIRED" &&
        this.privilege.selectParentOffice != "OPTIONAL"
      )
        return;
      return apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/offices",
      });
    },
    getSubOffices() {
      if (
        this.privilege.selectSubOffice != "REQUIRED" &&
        this.privilege.selectSubOffice != "OPTIONAL"
      )
        return;
      return apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/suboffices",
      });
    },

    getExecutorStructures(parentId) {
      if (
        this.privilege.selectParentOffice != "REQUIRED" &&
        this.privilege.selectParentOffice != "OPTIONAL"
      )
        return ;
      let url =
        URL[process.env.NODE_ENV].auth_api + "structures/execStructures";
      return apiCall({ url: url, params: { parentId: parentId } });
    },
    getSubExecStructures(parentId) {
      if (
        this.privilege.selectSubOffice != "REQUIRED" &&
        this.privilege.selectSubOffice != "OPTIONAL"
      )
        return;
      return apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/subExecStructure",
        params: { parentId: parentId },
      });
    },
    getMinistries() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures",
        params: { type: "MINISTRY", related: false },
      }).then((response) => {
        if (!response.data.error) {
          this.ministries = response.data.data.entities;
        }
      });
    },
    getTabHeader(detailOffice) {
      if (detailOffice.parentOffice)
        return detailOffice.problemSubOffices.length > 0
          ? detailOffice.problemSubOffices[
              detailOffice.problemSubOffices.length - 1
            ].office.name +
              " (" +
              detailOffice.parentOffice.name +
              ")" +
              (detailOffice.isCompleted ? " " : "") //(yekunlaşıb)
          : detailOffice.parentOffice.name +
              (detailOffice.isApproved == null
                ? " (Təsdiq gözləmədə)"
                : !detailOffice.isApproved
                ? " (Təsdiqlənməyib)"
                : "");
      else return detailOffice.curator.name;
    },
    getRelatedStructures() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures",
        method: "GET",
        params: { related: true },
      })
        .then((response) => {
          if (!response.data.error) {
            this.structuresAll = response.data.data.entities;
            this.filterStructures = this.structuresAll;
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    getRegions() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "common/regions",
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error) {
            this.regionsAll = response.data.data;
            this.filteredRegions = this.regionsAll;
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    getStreets(regId, keyword, executiveId) {
      //console.log(regId+' '+keyword+' '+executiveId)
      if ((!regId && !executiveId) || !keyword) {
        this.streetsAll = [];
        this.filterStreets = [];
        this.streetSpin = false;
        return;
      }
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "streets",
        method: "GET",
        params: { regionId: regId, key: keyword, executiveId: executiveId },
      })
        .then((response) => {
          if (!response.data.error) {
            this.streetsAll = response.data.data.entities;
            this.filterStreets = this.streetsAll;
          }
          this.streetSpin = false;
        })
        .catch((err) => {
          this.streetSpin = false;
        });
    },
    getExecutives(isAdmin) {
      getExecs(isAdmin)
        .then((response) => {
          if (!response.data.error) {
            this.executives = response.data.data.entities;
            this.filterExecutives = this.executives;
          } else {
            this.$message.error(response.data.error.message);
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
  },
};

export default mixin;
